module.exports = __webpack_public_path__ + "img/3yue.66bd1465.png";